import { TLinksConfig } from '../../types/links';

export const LINKS_CONFIG: TLinksConfig = {
  help: {
    href: 'https://hc.cian.ru/hc/ru',
    text: 'Справочный центр',
    label: 'help',
  },
  legalDocuments: {
    href: 'https://www.cian.ru/legal-documents/pravila_polzovaniya_sajtom_cian_0/',
    text: 'Юридические документы',
    label: 'legal-documents',
  },
  price: {
    href: '/price/?from=footer',
    text: 'Тарифы и цены',
    label: 'price',
  },
  advert: {
    href: 'https://www.cian.ru/help/re/advert/',
    text: 'Реклама на сайте',
    label: 'advert',
  },
  superAgent: {
    href: 'https://support.cian.ru/ru/knowledge_base/article/5311/category/69/',
    text: 'Программа «Суперагенты»',
    label: 'super_agent',
  },
  promo: {
    href: 'https://www.cian.ru/promo/adv/',
    text: 'Продвижение',
    label: 'promo',
  },
  auction: {
    href: 'https://www.cian.ru/help/auction/',
    text: 'Аукцион',
    label: 'auction',
  },
  searchOnMap: {
    href: 'https://www.cian.ru/map/',
    text: 'Поиск на карте',
    label: 'search_on_map',
  },
  tv: {
    href: 'https://www.cian.ru/tv/',
    text: 'Реклама Циана на ТВ',
    label: 'tv',
  },
  mortgageCalculator: {
    href: 'https://www.cian.ru/ipoteka/calculator/',
    text: 'Ипотечный калькулятор',
    label: 'mortgage-calculator',
  },
  legalCheck: {
    href: 'https://www.cian.ru/legal-check/?source=footer',
    text: 'Проверка недвижимости',
    label: 'legal-check',
  },
  sitemap: {
    href: 'https://www.cian.ru/sitemap/',
    text: 'Карта сайта',
    label: 'sitemap',
  },
  newOffers: {
    href: 'https://www.cian.ru/svezhie-obyavleniya/',
    text: 'Свежие объявления',
    label: 'svezhie-obyavleniya',
  },
  career: {
    href: 'https://www.cian.ru/vacancies/',
    text: 'Карьера в Циане',
    label: 'career',
  },
  contacts: {
    href: 'https://www.cian.ru/contacts/',
    text: 'Помощь',
    label: 'contact',
  },
  irLink: {
    href: 'https://ir.ciangroup.ru/',
    text: 'Сайт для инвесторов',
    label: 'investors',
  },
};
